import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';

export default function Portfolio() {
  const projects = [
    {
      title: 'E-Commerce Platform',
      category: 'Web Development',
      description: 'Full-featured online store with payment processing, inventory management, and customer portal.',
      technologies: ['React', 'Node.js', 'MongoDB', 'Stripe'],
      results: ['300% increase in online sales', '50K+ monthly visitors', '99.9% uptime']
    },
    {
      title: 'Mobile Banking App',
      category: 'Mobile Development',
      description: 'Secure iOS and Android banking application with biometric authentication and real-time transactions.',
      technologies: ['React Native', 'Firebase', 'AWS'],
      results: ['100K+ downloads', '4.8★ rating', 'Bank-grade security']
    },
    {
      title: 'Digital Marketing Campaign',
      category: 'Digital Marketing',
      description: 'Multi-channel marketing campaign for product launch including SEO, PPC, and social media.',
      technologies: ['Google Ads', 'Facebook Ads', 'SEO Tools'],
      results: ['500% ROI', '2M+ impressions', '15K+ conversions']
    },
    {
      title: 'Cloud Migration Project',
      category: 'Cloud Infrastructure',
      description: 'Complete migration of legacy systems to AWS cloud with improved scalability and security.',
      technologies: ['AWS', 'Docker', 'Kubernetes', 'Terraform'],
      results: ['60% cost reduction', '10x scalability', 'Zero downtime']
    },
    {
      title: 'SMS Campaign Platform',
      category: 'SMS Marketing',
      description: 'A2P 10DLC compliant SMS marketing platform for retail chain with 500+ locations.',
      technologies: ['Twilio', 'Python', 'PostgreSQL'],
      results: ['1M+ messages/month', '98% delivery rate', 'TCPA compliant']
    },
    {
      title: 'Email Automation System',
      category: 'Email Marketing',
      description: 'Automated email marketing system with segmentation, personalization, and analytics.',
      technologies: ['SendGrid', 'Node.js', 'React'],
      results: ['45% open rate', '12% click rate', '200K+ subscribers']
    }
  ];

  return (
    <>
      <Helmet>
        <title>Portfolio - TEJ Solutions Hub | Our Work & Success Stories</title>
        <meta name="description" content="Explore our portfolio of successful projects including web development, mobile apps, digital marketing, and cloud solutions." />
      </Helmet>

      <div style={{ paddingTop: '100px', background: '#f9fafb', minHeight: '100vh' }}>
        <div style={{ 
          background: `
            linear-gradient(135deg, rgba(124, 58, 237, 0.85) 0%, rgba(167, 139, 250, 0.85) 100%),
            url('https://images.unsplash.com/photo-1551434678-e076c223a692?w=1920&q=80')
          `,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          padding: '4rem 2rem', 
          color: 'white', 
          textAlign: 'center' 
        }}>
          <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
            <h1 style={{ fontSize: '3rem', fontWeight: '800', marginBottom: '1rem', textShadow: '0 4px 12px rgba(0,0,0,0.3)' }}>Our Portfolio</h1>
            <p style={{ fontSize: '1.25rem', textShadow: '0 2px 8px rgba(0,0,0,0.3)' }}>
              Successful projects that drive real business results
            </p>
          </div>
        </div>

        <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '4rem 2rem' }}>
          {/* Stats Section */}
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '2rem', marginBottom: '4rem' }}>
            <div style={{ background: 'white', padding: '2rem', borderRadius: '12px', textAlign: 'center', boxShadow: '0 4px 12px rgba(0,0,0,0.08)' }}>
              <div style={{ fontSize: '3rem', fontWeight: '800', color: '#7c3aed', marginBottom: '0.5rem' }}>100+</div>
              <div style={{ fontSize: '1rem', color: '#6b7280' }}>Projects Completed</div>
            </div>
            <div style={{ background: 'white', padding: '2rem', borderRadius: '12px', textAlign: 'center', boxShadow: '0 4px 12px rgba(0,0,0,0.08)' }}>
              <div style={{ fontSize: '3rem', fontWeight: '800', color: '#7c3aed', marginBottom: '0.5rem' }}>50+</div>
              <div style={{ fontSize: '1rem', color: '#6b7280' }}>Happy Clients</div>
            </div>
            <div style={{ background: 'white', padding: '2rem', borderRadius: '12px', textAlign: 'center', boxShadow: '0 4px 12px rgba(0,0,0,0.08)' }}>
              <div style={{ fontSize: '3rem', fontWeight: '800', color: '#7c3aed', marginBottom: '0.5rem' }}>5+</div>
              <div style={{ fontSize: '1rem', color: '#6b7280' }}>Years Experience</div>
            </div>
            <div style={{ background: 'white', padding: '2rem', borderRadius: '12px', textAlign: 'center', boxShadow: '0 4px 12px rgba(0,0,0,0.08)' }}>
              <div style={{ fontSize: '3rem', fontWeight: '800', color: '#7c3aed', marginBottom: '0.5rem' }}>98%</div>
              <div style={{ fontSize: '1rem', color: '#6b7280' }}>Client Satisfaction</div>
            </div>
          </div>

          {/* Projects Grid */}
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))', gap: '2rem' }}>
            {projects.map((project, idx) => (
              <div key={idx} style={{ background: 'white', borderRadius: '16px', overflow: 'hidden', boxShadow: '0 4px 20px rgba(0,0,0,0.08)', border: '2px solid #e5e7eb', transition: 'all 0.3s ease' }}>
                <div style={{ background: 'linear-gradient(135deg, #7c3aed 0%, #a78bfa 100%)', padding: '1rem 1.5rem' }}>
                  <div style={{ fontSize: '0.85rem', color: 'rgba(255,255,255,0.9)', fontWeight: '600', marginBottom: '0.25rem' }}>
                    {project.category}
                  </div>
                  <h3 style={{ fontSize: '1.5rem', fontWeight: '700', color: 'white' }}>
                    {project.title}
                  </h3>
                </div>
                
                <div style={{ padding: '2rem' }}>
                  <p style={{ fontSize: '1rem', color: '#6b7280', lineHeight: '1.8', marginBottom: '1.5rem' }}>
                    {project.description}
                  </p>

                  <div style={{ marginBottom: '1.5rem' }}>
                    <h4 style={{ fontSize: '0.9rem', fontWeight: '600', color: '#1f2937', marginBottom: '0.75rem' }}>
                      Technologies:
                    </h4>
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.5rem' }}>
                      {project.technologies.map((tech, i) => (
                        <span key={i} style={{ background: '#f3e8ff', color: '#7c3aed', padding: '0.25rem 0.75rem', borderRadius: '20px', fontSize: '0.85rem' }}>
                          {tech}
                        </span>
                      ))}
                    </div>
                  </div>

                  <div>
                    <h4 style={{ fontSize: '0.9rem', fontWeight: '600', color: '#1f2937', marginBottom: '0.75rem' }}>
                      Results:
                    </h4>
                    <ul style={{ fontSize: '0.95rem', color: '#4b5563', lineHeight: '2', paddingLeft: '1.5rem' }}>
                      {project.results.map((result, i) => (
                        <li key={i}>{result}</li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* CTA Section */}
          <div style={{ background: 'linear-gradient(135deg, #7c3aed 0%, #a78bfa 100%)', padding: '4rem 3rem', borderRadius: '16px', textAlign: 'center', color: 'white', marginTop: '4rem' }}>
            <h2 style={{ fontSize: '2.5rem', fontWeight: '800', marginBottom: '1rem' }}>Ready to Start Your Project?</h2>
            <p style={{ fontSize: '1.1rem', opacity: '0.95', marginBottom: '2rem', maxWidth: '600px', margin: '0 auto 2rem' }}>
              Let's create something amazing together. Contact us for a free consultation.
            </p>
            <Link to="/contact" style={{
              display: 'inline-block',
              background: '#fbbf24',
              color: '#1f2937',
              padding: '1.25rem 3rem',
              borderRadius: '12px',
              textDecoration: 'none',
              fontWeight: '700',
              fontSize: '1.1rem',
              boxShadow: '0 8px 24px rgba(251, 191, 36, 0.4)'
            }}>
              Get Started Today →
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}
